export default {
  offeringLegacyTitle: "Legacy of Leadership",
  offeringLegacyDescription: "40+ years of proven expertise in psychotropic APIs and complex generics",
  offeringGlobalTrustTitle: "Global Trust",
  offeringGlobalTrustDescription: "Strong relationships with top pharma innovators and generics across 80+ countries",
  offeringDiversePortfolioTitle: "Diverse Portfolio",
  offeringDiversePortfolioDescription: "Market leadership in CNS, antipsychotics, antihistamines, muscle relaxants, and expanding into high-barrier therapies",
  offeringQualityComplianceTitle: "Quality Compliance",
  offeringQualityComplianceDescription: "Delivering 100% quality compliance to ensure every product is consistent, safe, and reliable.",
  offeringIntegratedValueChainTitle: "Integrated Value Chain",
  offeringIntegratedValueChainDescription: "End-to-end strength across KSM, APIs, and FDFs, reducing supply chain risk and ensuring reliability",
  offeringWorldClassManufacturingTitle: "World-Class Manufacturing",
  offeringWorldClassManufacturingDescription: "Multiple sites in Karnataka, Andhra Pradesh, and global hubs in Italy and US, scaling seamlessly from grams to tons",
  offeringRegulatoryExcellenceTitle: "Regulatory Excellence",
  offeringRegulatoryExcellenceDescription: "Approvals and compliance across US, EU, and other major regulated markets",
  offeringPartnerOfChoiceTitle: "Partner of Choice",
  offeringPartnerOfChoiceDescription: "Trusted by 550+ customers worldwide for quality, speed, and regulatory support",
  offeringAgileSupplyChainTitle: "Agile Supply Chain",
  offeringAgileSupplyChainDescription: "Flexible, resilient operations ensuring consistent delivery in volatile environments",
  offeringSustainabilityCommitmentTitle: "Sustainability Commitment",
  offeringSustainabilityCommitmentDescription: "Embedding green chemistry, water-positive initiatives, and ESG practices into every process",
  offeringFutureReadyGrowthTitle: "Future-Ready Growth",
  offeringFutureReadyGrowthDescription: "Backed by Refex Group's financial strength, infrastructure, and vision for global expansion",
};

